import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { forkJoin, map } from 'rxjs';

import { environment } from '../../enviroment/enviroment';

export type FileItem<K extends string = 'file_path'> = Record<K, string> & Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class FileService {
  private readonly baseUrl = environment.ANGULAR_API_URL;
  private readonly http = inject(HttpClient);

  getSignedUrl$(key: string): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('hideLoader', 'false');
    return this.http
      .post<{
        statusCode: number;
        data?: string;
      }>(`${this.baseUrl}dashboard/signedURL`, { key }, { headers })
      .pipe(
        map((res) => {
          if (res.statusCode === 200 && res.data) {
            return res.data;
          }
          throw new Error('Signed URL generation failed');
        })
      );
  }

  mapSignedUrls$<T extends Record<K, string>, K extends keyof T>(
    items: T[],
    sourceKey: K,
    targetKey: K = sourceKey
  ): Observable<T[]> {
    return forkJoin(
      items.map((item) =>
        this.getSignedUrl$(item[sourceKey]).pipe(
          map((url) => ({
            ...item,
            [targetKey]: url,
          }))
        )
      )
    );
  }
}
